import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classes", "overrides", "className", "onChange", "value", "error", "inputs", "inputProps", "divider", "dividerText", "isFullWidth", "fieldsMode"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import InputWrapper from '../components/InputWrapper';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
var useStyles = createUseStyles(styles, 'FieldGroup');
var FieldGroup = /*#__PURE__*/memo(function (_ref) {
  var _classnames;
  var children = _ref.children,
    classesProp = _ref.classes,
    overridesProp = _ref.overrides,
    classNameProp = _ref.className,
    onChange = _ref.onChange,
    value = _ref.value,
    error = _ref.error,
    inputs = _ref.inputs,
    inputProps = _ref.inputProps,
    divider = _ref.divider,
    dividerText = _ref.dividerText,
    isFullWidth = _ref.isFullWidth,
    fieldsMode = _ref.fieldsMode,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(useStyles, classesProp);
  var override = getOverrides(overridesProp, FieldGroup.overrides);
  var rootClassName = classnames(classes.root, (_classnames = {}, _defineProperty(_classnames, classes.error, error), _defineProperty(_classnames, classes.isFullWidth, isFullWidth), _defineProperty(_classnames, classes.alignLabelTop, fieldsMode === 'vertical'), _classnames), classNameProp);
  var rangeWrapperClassName = classnames(classes.rangeWrapper, _defineProperty({}, classes.verticalFieldsMode, fieldsMode === 'vertical'));
  var onChangeInput = useCallback(function (newValue, index, event, info) {
    var changedValue = _toConsumableArray(value);
    changedValue[index] = newValue;
    onChange && onChange(changedValue, newValue, index, event, info);
  }, [onChange, value]);
  var Inputs = useMemo(function () {
    return inputs.reduce(function (inputNodes, Input, index) {
      var props = {};
      if (inputProps && Array.isArray(inputProps) && inputProps[index]) props = inputProps[index];else if (inputProps) props = inputProps;
      inputNodes.push( /*#__PURE__*/React.createElement(Input, _extends({
        key: index,
        isFullWidth: isFullWidth,
        error: !!error,
        onChange: function onChange(value, event, info) {
          return onChangeInput(value, index, event, info);
        },
        value: value[index]
      }, props)));

      // Adding dividers
      if (inputs[index + 1] && fieldsMode !== 'vertical' && (divider || dividerText)) {
        if (divider) inputNodes.push( /*#__PURE__*/React.createElement("div", _extends({
          key: "".concat(index, "-divider"),
          className: classes.divider
        }, override.divider), divider));else if (dividerText) inputNodes.push( /*#__PURE__*/React.createElement("div", _extends({
          key: "".concat(index, "-divider"),
          className: classes.divider
        }, override.divider), /*#__PURE__*/React.createElement("span", _extends({
          className: classes.dividerText
        }, override.dividerText), dividerText)));
      }
      return inputNodes;
    }, []);
  }, [classes.divider, classes.dividerText, divider, dividerText, error, inputProps, inputs, isFullWidth, onChangeInput, override.divider, override.dividerText, value, fieldsMode]);
  return /*#__PURE__*/React.createElement(InputWrapper, _extends({}, props, {
    error: error,
    isFullWidth: isFullWidth,
    className: rootClassName,
    overrides: overridesProp
  }), /*#__PURE__*/React.createElement("div", _extends({
    className: rangeWrapperClassName
  }, override.rangeWrapper), Inputs));
});
FieldGroup.overrides = ['root', 'rangeWrapper', 'divider', 'dividerText'];
FieldGroup.defaultProps = _objectSpread(_objectSpread({}, InputWrapper.defaultProps), {}, {
  onChange: function onChange() {},
  value: [],
  overrides: {},
  inputs: [],
  dividerText: '',
  fieldsMode: 'horizontal'
});
process.env.NODE_ENV !== "production" ? FieldGroup.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  label: PropTypes.string,
  labelMode: PropTypes.oneOf(['horizontal', 'vertical']),
  fieldsMode: PropTypes.oneOf(['horizontal', 'vertical']),
  isFullWidth: PropTypes.bool,
  /** Info popover */
  hint: PropTypes.string,
  /** Error will be displayed below the component with style changes */
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /** Info will be displayed below the component with style changes */
  info: PropTypes.string,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.array,
  inputs: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  /**An array for individual field customization or and object for apply it to all fields */
  inputProps: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  /** Component for overwrite whole divider */
  divider: PropTypes.any,
  /** Divider text for enable it */
  dividerText: PropTypes.string
} : void 0;
export default FieldGroup;